import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpButton } from '../components/ui/HelpButton';
import type { HelpContextId } from './contexts';
import { useHelp } from './helpApi';

/**
 * The "?" in a dialog header. While the dialog is open the "?" key opens this dialog's help (not the
 * page's); the side sheet opens over the dialog and Escape closes only the sheet.
 */
export function DialogHelp({ context, title }: { context: HelpContextId; title: string }) {
  const { t } = useTranslation();
  const { openHelp, pushLayer } = useHelp();
  const layer = useMemo(() => ({ context, title }), [context, title]);
  useEffect(() => pushLayer(layer), [pushLayer, layer]);
  return <HelpButton label={t('help.buttonLabel', { page: title })} onClick={() => openHelp(layer)} />;
}
